module.exports = __webpack_public_path__ + "static/media/warning-icon.c81e5c4c.svg";